import api from "../../api";

function initialState() {
  return {
    notifications: [],
  };
}

const notificationsModule = {
  state: initialState,
  getters: {
    newsNotifications: (state) =>
      state.notifications.filter(
        (notification) => notification.notificationType === "NewsArticle"
      ),
    newsletterNotifications: (state) =>
      state.notifications.filter(
        (notification) => notification.notificationType === "News"
      ),
    eventNotifications: (state) =>
      state.notifications.filter(
        (notification) => notification.notificationType === "Event"
      ),
    statusNotifications: (state) =>
      state.notifications.filter(
        (notification) => notification.notificationType === "Status"
      ),
    notifications: (state) => state.notifications,
    filteredNotifications: (state, rootState) => {
      let notifications = state.notifications;

      // for each school
      rootState.mySchools.forEach((school) => {
        // if push notifications are turned off for news, filter out news from notifications inbox
        if (!school.pushNotifications.news) {
          notifications = notifications.filter((notification) => {
            return !(
              notification.schoolId === school.schoolId &&
              notification.notificationType === "NewsArticle"
            );
          });
        }

        // if push notifications are turned off for events, filter out events from notifications inbox
        if (!school.pushNotifications.event) {
          notifications = notifications.filter((notification) => {
            return !(
              notification.schoolId === school.schoolId &&
              notification.notificationType === "Event"
            );
          });
        }

        // if push notifications are turned off for newsletters, filter out newsletters from notifications inbox
        if (!school.pushNotifications.newsletter) {
          notifications = notifications.filter((notification) => {
            return !(
              notification.schoolId === school.schoolId &&
              notification.notificationType === "Newsletter"
            );
          });
        }
      });

      return notifications;
    },
  },
  mutations: {
    SET_NOTIFICATIONS: function(state, notifications) {
      state.notifications = notifications;
    },
    RESET_NOTIFICATIONS: function(state) {
      const s = initialState();
      Object.keys(s).forEach((key) => {
        state[key] = s[key];
      });
    },
  },
  actions: {
    fetchNotifications: function({ commit }) {
      if (!this.getters.isLoading) {
        commit("SET_IS_LOADING", true);
      }
      let activeSchools = this.getters.mySchools.map(
        (school) => school.schoolId
      );
      api.notifications
        .fetchNotifications(activeSchools)
        .then((response) => {
          commit("SET_NOTIFICATIONS", response);
        })
        .finally(() => {
          if (this.getters.isLoading) {
            commit("SET_IS_LOADING", false);
          }
        });
    },
  },
};
export default notificationsModule;
